import * as wx from './wx';
import * as boc from './boc';

export default {
  wx,
  boc,
};
